import * as React from 'react';
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CampusProofCard} from '../ProofEdit/CampusProofCard';
import {Button} from '../Components/Button';
import {CampusFrontLocator} from '../TextEdit/CampusFrontLocator';
import {CampusBackLocator} from '../TextEdit/CampusBackLocator';
import {TextEditPopup} from '../TextEdit/TextEditPopup';


class Props extends Tgcc.BaseProps{
    frontText: string;
    backText: string;
    frontLocation: string;
    backLocation: string;
}

const iconFrontStyle : CSSProperties = {
    backgroundColor: 'transparent',
    height: '17px',
    display: 'flex',
    alignSelf: 'center',
    marginBottom: '2px',
    marginTop: '-4px'
}

const iconBackStyle : CSSProperties = {
    backgroundColor: 'transparent',
    height: '17px',
    display: 'flex',
    alignSelf: 'center',
    marginBottom: '2px',
    marginTop: '2px'
}

const textStyle : CSSProperties  = {
    fontFamily: 'AveriaSerifLightItalic',
    fontSize: '15px',
    letterSpacing: '2px',
    textAlign: 'center',
    alignSelf: '',
    border: '1px solid #E9E6E6',
    borderSpacing: 0,
    height: '90px',
    width: '290px',
    resize: 'none',
    overflowY: 'hide',
    overflowX: 'auto',
    cursor: 'pointer',
    color:'#616060',
}

const innerCont: CSSProperties = {
    textAlign:'center'
}

const printBtnStyle: CSSProperties = {
    backgroundColor:'#DF735B',
    color:'white',
    width:'254px',
    height:'35px',
    margin:'auto',
    lineHeight:'3.2em',
    fontFamily:'Reitam',
    fontSize:'11px',
    border:'1px solid black',
    cursor:'pointer'
}

const text: React.CSSProperties = {
    fontFamily:'Reitam',
    color:'#616060',
    fontSize:'14px'
}

class _IndigoTextEdit extends React.Component<Props, any>{
    editFrontText = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.EditFrontText})
    }
    setFrontText = (text: string) => {
        this.props.dispatch({type: Tgcc.StateAction.SetFrontText, payload: text})
    }

    editBackText = () => {
        this.props.dispatch({ type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.EditBackText})
    }
    setBackText = (text: string) => {
        this.props.dispatch({type: Tgcc.StateAction.SetBackText, payload: text})
    }

    getLocationButton(text: string, imgSrc: string, selector: ()=>void){
        var btnStyle: CSSProperties = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '30px',
            padding: '3px',
            cursor: 'pointer'
        }
        var imgStyle: CSSProperties = {
            display: 'flex',
            alignSelf: 'center',
            height: '100%'
        }
        var txtStyle: CSSProperties = {
            display: 'flex',
            alignSelf: 'center',
            fontSize: '10px',
            textTransform: 'uppercase',
            fontFamily: 'CenturyGothic',
            backgroundColor: Tgcc.Styles.inputBackground,
            margin: "0 5px",
            padding: "2px 10px"
        }
        return (
            <div className="hoverBorder" style={btnStyle} onClick={selector}>
                <img src={imgSrc} style={imgStyle}/>
                <div style={txtStyle}>{text}</div>
            </div>
        )
    }

    getFrontLocationButton(){
        var defaultBtn = (<div style={printBtnStyle} onClick={this.selectFrontLocation}>CHOOSE FRONT LOCATION</div>);
        var txt: string;
        var img: string;
        switch(this.props.frontLocation){
            case Tgcc.FrontLocations.FrontLeftorPocket:
                return this.getLocationButton("front left/pocket", Tgcc.ResolveUrl('~/images/Left.Pocket.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.SmallFront:
                return this.getLocationButton("small front", Tgcc.ResolveUrl('~/images/Small.Front.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.MediumFront:
                return this.getLocationButton("medium front", Tgcc.ResolveUrl('~/images/Medium.Front.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.FullFront:
                return this.getLocationButton("full front", Tgcc.ResolveUrl('~/images/Full.Front.png'), this.selectFrontLocation);
            case Tgcc.FrontLocations.None: 
            default: 
                return defaultBtn;
        }
    }

    getBackLocationButton(){
        var defaultBtn = (<div style={printBtnStyle} onClick={this.selectBackLocation}>CHOOSE BACK LOCATION</div>);
        switch(this.props.backLocation){
            case Tgcc.BackLocations.SmallBack:
                return this.getLocationButton("small back",Tgcc.ResolveUrl('~/images/Small.Front.png'), this.selectBackLocation);
            case Tgcc.BackLocations.MediumBack:
                return this.getLocationButton("medium back",Tgcc.ResolveUrl('~/images/Medium.Front.png'), this.selectBackLocation);
            case Tgcc.BackLocations.FullBack:
                return this.getLocationButton("full back",Tgcc.ResolveUrl('~/images/Full.Front.png'), this.selectBackLocation);
            case Tgcc.BackLocations.None: 
            default:
                return defaultBtn;            
        }
    }

    render(){
        var frontText: string = this.props.frontText ? this.props.frontText : "";
        var backText: string = this.props.backText ? this.props.backText : "";

        return (
        <div>
            <CampusProofCard title=" 3. Customize">
                <div style={innerCont}>
                    <div style={text}>Front</div>
                    <textarea className="hoverBorder" readOnly={true}  style={textStyle} onClick={this.editFrontText} value={frontText} placeholder="Text for front, specifications, and other requests."/>
                    {this.getFrontLocationButton()}
                    <div style={text}>Back</div>
                    <textarea className="hoverBorder" readOnly={true}  style={textStyle} onClick={this.editBackText} value={backText} placeholder="Text for back, specifications, and other requests."/>
                    {this.getBackLocationButton()}
                </div>
            </CampusProofCard>
            <TextEditPopup text={frontText} title="Front Text" editState={Tgcc.EditStates.EditFrontText} addToProof={this.setFrontText} fontFamily='AveriaSerifLightItalic'/>
            <TextEditPopup text={backText} title="Back Text" editState={Tgcc.EditStates.EditBackText} addToProof={this.setBackText} fontFamily='AveriaSerifLightItalic'/>
            <CampusFrontLocator />
            <CampusBackLocator />
        </div>
        )
    }


    selectFrontLocation = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.SelectFrontLocation});
    }

    selectBackLocation = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.SelectBackLocation});
    }

}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    var newProps = { 
        frontText: state.ActiveProof.text.front,
        frontLocation: state.ActiveProof.frontLocation,
        backText: state.ActiveProof.text.back,
        backLocation: state.ActiveProof.backLocation
    };
    return newProps;
};

export var IndigoTextEdit = connect(mapStateToProps)(_IndigoTextEdit);